/*
 * Helper to allow importing of the env config.
 *    import config from 'configs/env-config';
 *        OR
 *    ENVConfig.VARIABLE // Auto import.
 */
export default {
    ...(process.env.CONFIG || {}),
}
